import React, { useState } from "react";
import { connect } from "react-redux";
import { createCertification } from "./actions";

const NewCertificationForm = ({ onCreatePressed }) => {

    const [name, setName] = useState('');
    const [orgnization, setOrgnization] = useState('');
    const [issueDate, setIssueDate] = useState('');
    const [issued_by, setIssuedBy] = useState('');
    const [file, setFile] = useState('');
    const handleFileChange = (e) => {
        setFile(e.target.value);
    }

    const saveCertification = () => {
        onCreatePressed({ name, orgnization, issueDate, issued_by, file });
        setName('');
        setOrgnization('');
        setIssueDate('');
        setIssuedBy('');
        setFile('');
    }

    return (
        <div className="border rounded bg-light p-3 m-2">
            <div style={{ display: 'flex', justifyContent: 'start', gap: '10px', marginBottom:'10px' }}>
                <div>
                    <label style={{ margin: '0', padding: '0' }} htmlFor="position">Certification/Achievement Title</label>
                    <input
                        className="form-control"
                        type="text"
                        placeholder="Certification/Achievement Title"
                        value={name}
                        onChange={e => setName(e.target.value)}
                        name="name"
                        style={{ padding: '7px' }}
                    />
                </div>
                <div>
                    <label style={{ margin: '0', padding: '0' }} htmlFor="position">Orgnization Name</label>
                    <input
                        className="form-control"
                        type="text"
                        placeholder="Organization"
                        value={orgnization}
                        onChange={e => setOrgnization(e.target.value)}
                        name="orgnization"
                        style={{ padding: '7px' }}
                    />
                </div>
                <div>
                    <label style={{ margin: '0', padding: '0' }} htmlFor="position">Issue Date</label>
                    <input
                        className="form-control"
                        type="date"
                        placeholder="Issue Date"
                        value={issueDate}
                        onChange={e => setIssueDate(e.target.value)}
                        name="issueDate"
                        style={{ padding: '5px' }}
                    />
                </div>
            </div>
            <div style={{ display: 'flex', justifyContent: 'start', gap: '10px' }}>
                <div>
                    <label style={{ margin: '0', padding: '0' }} htmlFor="position">Issued By</label>
                    <input
                        className="form-control"
                        type="text"
                        placeholder="Issued By"
                        value={issued_by}
                        onChange={e => setIssuedBy(e.target.value)}
                        name="issued_by"
                        style={{ padding: '7px' }}
                    />
                </div>
                <div>
                    <label style={{ margin: '0', padding: '0' }} htmlFor="position">Upload Certification</label>
                    <input
                        className="form-control"
                        style={{ padding: '5px' }}
                    onChange={handleFileChange} type="file" accept="application/pdf" />
                </div>
            </div>
            <div style={{display:'flex',justifyContent:'end'}}>
                <button
                    className="btn btn-success btn-sm rounded-circle"
                    disabled={name === ''}
                    onClick={saveCertification}
                >
                    Add
                </button>
            </div>
        </div>
    )
}

const mapStateToProps = state => ({
    certification: state.certification,
});

const mapDispatchToProps = dispatch => ({
    onCreatePressed: certificate => dispatch(createCertification(certificate)),
});

export default connect(mapStateToProps, mapDispatchToProps)(NewCertificationForm);



// export default connect(null, { createCertification })(NewCertificationForm);